import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param organisationId string
 * @param userId Number
 * @return {Promise<any>|Promise}
 */
export default (function (organisationId, userId) {
    var url = applyPathVariables(EndPoints.ORGANISATION_USERS_ID, {
        organisationId: organisationId,
        userId: userId
    });
    var request = new Request({ method: Methods.DELETE, url: url, withCredentials: true });
    return request.execute();
});
